import { useSearchPageStore } from "@/stores/SearchPage";
import { type RouteLocationNormalized } from 'vue-router';

const {
	setShowAllSearch
} = useSearchPageStore();

export default defineNuxtRouteMiddleware((to: RouteLocationNormalized) => {
	if (import.meta.client) {
		setShowAllSearch(to.query.type as string);
	}
});